import { RegularButton } from 'pg-ui-library';
import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const FormTitle = styled.p`
  font-family: BiotifMedium;
  color: #1c1b3a;
  font-size: 22px;
  margin: 0;
  text-align: center;
`;

export const CloseIcon = styled.img`
  height: auto;
  width: 14px;
  cursor: pointer;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalContent = styled.div`
  display: flex;
`;

export const FormRow = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr; /* Divide the available space into two equal parts */
  grid-gap: 10px; /* Optional: Adds a gap between the inputs */
  margin-top: 20px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
`;

export const ContainerValidation = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormButton = styled(RegularButton)`
  margin: 0;
  min-width: 155px;
`;
